
export default {
  data() {
    return {
      modelViewerLoaded: false,
      imageIndex: 0,
      imageTransform: 'opacity:0;',
      rotateIndex: 0,
      modelHeight: '500px',
      modelWidth: '650px',
      cameraControls: true,
      scrollStopped: true,
      showModel: false,
      stopedTimeou: -1,
      modelKey: 1,
      rotateLevel: 0,
      modelVisiblity: true,
    }
  },
  props: {
    name: {
      default: '',
    },
    model: {
      default: '',
    },
    poster: {
      default: '',
    },
    velocity: {
      default: 4,
    },
    initModelHeight: {
      default: '60vh',
    },
  },
  methods: {
    SHOW_MODEL(show = true, event) {
      if (show) {
        this.showModel = show
        document.body.classList.add('overflow-hidden')
        this.modelHeight = '100vh'
        this.modelWidth = '55vw'
      } else if (!event.target.id.includes('model-viewer')) {
        if (this.showModel && !show) this.modelKey += this.modelKey

        this.showModel = show
        document.body.classList.remove('overflow-hidden')
        this.modelWidth = '650px'
      }
    },
    ROTATE_IMAGE() {
      if (this.stopedTimeou > 0) {
        clearTimeout(this.stopedTimeou)
        this.scrollStopped = true
      }
      this.stopedTimeou = setTimeout(() => {
        this.scrollStopped = true
      }, 500)
      let step = 100 * this.velocity
      if (window.innerWidth <= 579) {
        this.modelHeight = '10vh'
        step = 100 * this.velocity * 1.2
        rotateEndRule = 1
      }
      const viewerEnd = document.getElementById('viewer-end').offsetTop + 100
      const videoHeight = document.getElementById('video').offsetHeight - 500
      const rotateEnd = viewerEnd + videoHeight
      const scrollY = window.scrollY - videoHeight
      const value = (scrollY % step) / ((step * 50) / 1600)
      const level = Math.ceil(scrollY / step)
      let extraStyle = ''
      let unit = 1.48
      if (rotateEnd <= scrollY + 400 || scrollY < 80) {
        extraStyle = `top: auto;left:-175px!important;bottom:-100px;opacity:1;transform: translate(0,0)!important;opacity:${
          this.showModel
            ? '1!important;'
            : `0 !important;visibility: hidden;pointer-events:none !important;display:none;`
        };`
        this.modelHeight = this.initModelHeight
        this.modelVisiblity = false
      } else if (window.innerWidth <= 579) {
        this.modelHeight = '400px'
        extraStyle += `;top:200px;`
        this.modelVisiblity = true
      } else {
        this.modelHeight = this.initModelHeight
        this.modelVisiblity = true
      }
      if (scrollY < 20) {
        this.imageTransform = `left:50%; top:340px;${extraStyle};pointer-events:visible !important;`
        this.cameraControls = true
      } else if (level % 4 === 1) {
        this.rotateLevel = 0
        if (value === 0) return
        this.imageTransform = `left:${
          50 - value * unit
        }%; transform: translate(-${50 - value * unit}%, -50%);${extraStyle}`
      } else if (level % 4 === 2) {
        this.rotateLevel = 1
        if (value === 0) return
        this.imageTransform = `left:${
          0 + value * unit
        }%; transform: translate(-${0 + value * unit}%, -50%);${extraStyle}`
      } else if (level % 4 === 3) {
        this.rotateLevel = 2
        if (value === 0) return
        this.imageTransform = `left:${
          50 + value * unit
        }%; transform: translate(-${50 + value * unit}%, -50%);${extraStyle}`
      } else if (level % 4 === 0) {
        this.rotateLevel = 3
        if (value === 0) return

        this.imageTransform = `left:${
          100 - value * unit
        }%; transform: translate(-${100 - value * unit}%, -50%);${extraStyle}`
      }
      if (scrollY > 20) this.cameraControls = false
    },
  },
  beforeDestroy() {
    document.body.onscroll = null
  },
  mounted() {
    this.modelHeight = this.initModelHeight

    setTimeout(() => {
      if (window.innerWidth > 992) document.body.onscroll = this.ROTATE_IMAGE
      else this.modelVisiblity = false
    }, 250)
  },
}
